import { render, staticRenderFns } from "./dataCenter.vue?vue&type=template&id=5cfbc520&scoped=true&"
import script from "./dataCenter.vue?vue&type=script&lang=js&"
export * from "./dataCenter.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/common/nav.less?vue&type=style&index=0&id=5cfbc520&scoped=true&lang=less&"
import style1 from "../../assets/css/common/operating.less?vue&type=style&index=1&id=5cfbc520&scoped=true&lang=less&"
import style2 from "../../assets/css/common/table.less?vue&type=style&index=2&id=5cfbc520&scoped=true&lang=less&"
import style3 from "../../assets/css/common/card.less?vue&type=style&index=3&id=5cfbc520&scoped=true&lang=less&"
import style4 from "../../assets/css/common/details.less?vue&type=style&index=4&id=5cfbc520&scoped=true&lang=less&"
import style5 from "../../assets/css/common/eattribute.less?vue&type=style&index=5&id=5cfbc520&scoped=true&lang=less&"
import style6 from "./dataCenter.vue?vue&type=style&index=6&id=5cfbc520&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfbc520",
  null
  
)

export default component.exports